/** vite `define` — `apps/web/vite.config.mts`가 package.json 버전을 박는다. */
declare const __APP_VERSION__: string;

/** 웹 번들 버전 — 더보기의 앱 버전 줄과 문의 메일이 같은 값을 적는다. */
export const APP_VERSION = __APP_VERSION__;
